 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import TEXT9780062390974_COVER from '@/components/text/9780062390974_Cover'
 import LOVE_1 from '@/components/love_1'
 import TEXT9780062390974_TITLEPAGE from '@/components/text/9780062390974_Titlepage'
 import TEXT9780062390974_DEDICATION from '@/components/text/9780062390974_Dedication'
 import TEXTNAV from '@/components/text/nav'
 import TEXT9780062390974_INTRODUCTION from '@/components/text/9780062390974_Introduction'
 import TEXT9780062390974_P1 from '@/components/text/9780062390974_P1'
 import TEXT9780062390974_CH001 from '@/components/text/9780062390974_Ch001'
 import TEXT9780062390974_CH002 from '@/components/text/9780062390974_Ch002'
 import TEXT9780062390974_CH003 from '@/components/text/9780062390974_Ch003'
 import TEXT9780062390974_CH004 from '@/components/text/9780062390974_Ch004'
 import TEXT9780062390974_P2 from '@/components/text/9780062390974_P2'
 import TEXT9780062390974_CH005 from '@/components/text/9780062390974_Ch005'
 import TEXT9780062390974_CH006 from '@/components/text/9780062390974_Ch006'
 import TEXT9780062390974_CH007 from '@/components/text/9780062390974_Ch007'
 import TEXT9780062390974_CH008 from '@/components/text/9780062390974_Ch008'
 import TEXT9780062390974_CH009 from '@/components/text/9780062390974_Ch009'
 import TEXT9780062390974_CH010 from '@/components/text/9780062390974_Ch010'
 import TEXT9780062390974_P3 from '@/components/text/9780062390974_P3'
 import TEXT9780062390974_CH011 from '@/components/text/9780062390974_Ch011'
 import TEXT9780062390974_CH012 from '@/components/text/9780062390974_Ch012'
 import TEXT9780062390974_P4 from '@/components/text/9780062390974_P4'
 import TEXT9780062390974_CH013 from '@/components/text/9780062390974_Ch013'
 import TEXT9780062390974_CH014 from '@/components/text/9780062390974_Ch014'
 import LOVE_2 from '@/components/love_2'
 import TEXT9780062390974_ACKNOWLEDGMENTS from '@/components/text/9780062390974_Acknowledgments'
 import TEXT9780062390974_SCIENTIFICBIBLIOGRAPHY from '@/components/text/9780062390974_ScientificBibliography'
 import TEXT9780062390974_INDEX from '@/components/text/9780062390974_Index'
 import TEXT9780062390974_ATA from '@/components/text/9780062390974_ATA'
 import TEXT9780062390974_CREDITS from '@/components/text/9780062390974_Credits'
 import TEXT9780062390974_COPYRIGHT from '@/components/text/9780062390974_Copyright'
 import TEXT9780062390974_ATP from '@/components/text/9780062390974_ATP'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/text/nav",
 			"name" : "text/nav",
 			"component" : TEXTNAV
 		},
 		{
 			"path" : "/text/9780062390974_Introduction",
 			"name" : "text/9780062390974_Introduction",
 			"component" : TEXT9780062390974_INTRODUCTION
 		},
 		{
 			"path" : "/text/9780062390974_P1",
 			"name" : "text/9780062390974_P1",
 			"component" : TEXT9780062390974_P1
 		},
 		{
 			"path" : "/text/9780062390974_Ch001",
 			"name" : "text/9780062390974_Ch001",
 			"component" : TEXT9780062390974_CH001
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js